import { cn } from '@/lib/utils'

export interface PathInterface {
  name: string
  action?: () => void
}

interface BreadCrumbProp {
  paths: PathInterface[]
  icon: React.ReactNode
  className?: string
}

export default function Breadcrumb({ paths, icon, className }: BreadCrumbProp) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        'mb-3 flex w-full border-b border-gray-300 shadow-sm',
        className
      )}
    >
      <ol
        className="flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6"
        role="list"
      >
        <li className="flex">
          <div className="flex items-center">
            <div className="text-gray-400 hover:text-gray-500">
              {icon}
              <span className="sr-only">Home</span>
            </div>
          </div>
        </li>
        {paths.map((current) => (
          <li className="flex" key={current.name}>
            <div
              className={cn(
                'flex items-center hover:cursor-default',
                current.action && 'hover:cursor-pointer hover:text-gray-700'
              )}
              onClick={() => (current.action ? current.action() : null)}
            >
              <svg
                aria-hidden="true"
                className="h-full w-6 flex-shrink-0 text-gray-300"
                fill="currentColor"
                preserveAspectRatio="none"
                viewBox="0 0 24 44"
              >
                <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
              </svg>
              <p
                className={cn(
                  'ml-4 text-sm font-medium text-gray-500',
                  current.action && 'hover:text-gray-700'
                )}
              >
                {current.name}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  )
}
